import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ProgressBar from 'components/ProgressBar';
import Button from 'components/Button';
import Input from 'components/Input';
import Dropdown from "components/Dropdown";
import InputMask from 'react-input-mask';
import { usePlacesWidget } from 'react-google-autocomplete'
import { Head, Container, Content, Row, Footer } from "./styles";

const CustomerIdentification = ({status}) => {

  const navigate = useNavigate();
  const location = useLocation();
  const groupId = useParams().groupId;
  const scan = location.state?.scanData?.scan;

  const [guestInfo, setGuestInfo] = useState({
    fullName: scan?.fullName || "",
    dateOfBirth: scan?.dateOfBirth || "",
    address: scan?.address || "",
    travelDocumentNumber: "",
    travelDocumentType: "",
    documentExpiry: "",
    documentRegion: "",
  });

  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_APIKEY,
    onPlaceSelected: (place) => {
      const components = place.address_components || [];

      const getComponent = (type) =>
        components.find((component) => component.types.includes(type))
          ?.long_name || "";

      const streetNumber = getComponent("street_number");
      const route = getComponent("route");

      const streetAddress = [streetNumber, route].filter(Boolean).join(" ");
      const streetAddressLine2 = ""; // Google Autocomplete doesn't return this
      const city =
        getComponent("locality") || getComponent("sublocality") || "";
      const province = getComponent("administrative_area_level_1");
      const postalCode = getComponent("postal_code");
      const country = getComponent("country");
      setGuestInfo({
        ...guestInfo,
        streetAddress,
        streetAddressLine2,
        city,
        province,
        postalCode,
        country,
      });
    },
    options: {
      types: ["address"],
    },
  });

  const handleContinue = () => {
    navigate(`/group-check-in/payment/${groupId}`);
  };

  return (
    <Container>
      <ProgressBar step={2} groupId={groupId} status={status}/>
      <Content>
        <Head>Customer Identification</Head>
        <Row>
          <Input
            title="NAME"
            value={guestInfo.fullName}
            onChange={(e) => {
              setGuestInfo((guestInfo) => ({
                ...guestInfo,
                fullName: e.target.value,
              }));
            }}
            additionalstyle={`
                flex-basis: 100%;
              `}
          />
          <InputMask
            mask={[
              /[0-1]/,
              /[0-9]/,
              "/",
              /[0-3]/,
              /[0-9]/,
              "/",
              /[1-2]/,
              /[0-9]/,
              /[0-9]/,
              /[0-9]/,
            ]}
            maskPlaceholder="__/__/____"
            value={guestInfo.dateOfBirth}
            onChange={(e) => {
              setGuestInfo((guestInfo) => ({
                ...guestInfo,
                dateOfBirth: e.target.value,
              }));
            }}
          >
            <Input
              title="DOB (MM/DD/YYYY)"
              additionalstyle={`
                  flex-basis: 100%;
                `}
            />
          </InputMask>
        </Row>
        <Row>
          <Input
            inputFieldRef={ref}
            title="ADDRESS"
            value={guestInfo.streetAddress}
            onChange={(e) => {
              setGuestInfo((guestInfo) => ({
                ...guestInfo,
                streetAddress: e.target.value,
              }));
            }}
            additionalstyle={`
                flex-basis: 100%;
              `}
          />
        </Row>
        <Row>
          <Input
            title="TRAVEL DOCUMENT #"
            value={guestInfo.travelDocumentNumber}
            onChange={(e) => {
              setGuestInfo((guestInfo) => ({
                ...guestInfo,
                travelDocumentNumber: e.target.value,
              }));
            }}
            additionalstyle={`
                flex-basis: 100%;
              `}
          />
          <Dropdown
            title="TRAVEL DOCUMENT TYPE"
            options={['Passport', 'Drivers License']}
            value={guestInfo.travelDocumentType}
            onChange={(e) => {
              setGuestInfo((guestInfo) => ({
                ...guestInfo,
                travelDocumentType: e.target.value,
              }))
            }}
          />
        </Row>
        <Row>
          <InputMask
            mask={[
              /[0-1]/,
              /[0-9]/,
              "/",
              /[0-3]/,
              /[0-9]/,
              "/",
              /[1-2]/,
              /[0-9]/,
              /[0-9]/,
              /[0-9]/,
            ]}
            maskPlaceholder="__/__/____"
            value={guestInfo.documentExpiry}
            onChange={(e) => {
              setGuestInfo((guestInfo) => ({
                ...guestInfo,
                documentExpiry: e.target.value,
              }));
            }}
          >
            <Input
              title="DOCUMENT EXPIRY"
              additionalstyle={`
                  flex-basis: 100%;
                `}
            />
          </InputMask>
          <Dropdown
            title="DOCUMENT REGION"
            options={[]}
            value={guestInfo.travelDocumentType}
            onChange={(e) => {
              setGuestInfo((guestInfo) => ({
                ...guestInfo,
                travelDocumentType: e.target.value,
              }))
            }}
          />
        </Row>
        <Footer>
          <div className="buttonContainer">
            <Button
              success
              additionalstyle={`
                width: 72px;
              `}
              onClick={handleContinue}
            >
              Continue
            </Button>
          </div>
        </Footer>
      </Content>
    </Container>
  );
};

export default CustomerIdentification;
